import type { ReactNode } from 'react';
import { Menu } from '@kula-ai/components';
import type { WorkdayHireType } from './hireType';

export interface WorkdayHireMenuProps {
  /**
   * The button that opens it.
   *
   * Supplied by the caller rather than built here: the three surfaces that
   * offer this each use a different button — the hired-stage card `KButton`,
   * the modal Chakra's — and a trigger of its own would sit beside neighbours
   * it does not match in size, colour or alignment.
   */
  trigger: ReactNode;
  onSelect: (_hireType: WorkdayHireType) => void;
}

/**
 * The two Workday hire types, behind one control.
 *
 * One menu rather than two buttons: the recruiter is picking *how* to do one
 * action, not choosing between two, and it matches the "Add to HRIS" menu they
 * already use.
 */
export const WorkdayHireMenu = ({
  trigger,
  onSelect,
}: WorkdayHireMenuProps) => (
  <Menu
    align="end"
    trigger={trigger}
    items={[
      {
        key: 'new_hire',
        label: 'New hire',
        onClick: () => onSelect('new_hire'),
      },
      { key: 'rehire', label: 'Rehire', onClick: () => onSelect('rehire') },
    ]}
  />
);

export default WorkdayHireMenu;
